module.exports = __webpack_public_path__ + "6d74740ab59023b4923f86e680f5e230.ttf";